<template>
  <div class="hello pt-4">

<main role="main">
  <div id="myCarousel" class="container carousel slide pt-5" data-ride="carousel" style="margin-bottom: 0px;">
    <ol class="carousel-indicators">
      <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
      <li data-target="#myCarousel" data-slide-to="1"></li>
      <li data-target="#myCarousel" data-slide-to="2"></li>
      <li data-target="#myCarousel" data-slide-to="3"></li>
      <li data-target="#myCarousel" data-slide-to="4"></li>
      <li data-target="#myCarousel" data-slide-to="5"></li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img style="width:100%" class="img img-responsive" src="img/picture_1.jpg" alt="">
        <!-- <img class="bd-placeholder-img" width="100%" height="100%" xmlns="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTOVPpBJ-rs-daY9UaJoBIY_vvhSQOWhFrLfA" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"></img> -->
      </div>
      <div class="carousel-item">
        <img style="width:100%" class="img img-responsive" src="img/picture_2.jpg" alt="">
        <!-- <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><rect width="100%" height="100%" fill="#777"/></svg> -->
      </div>
      <div class="carousel-item">
        <img style="width:100%" class="img img-responsive" src="img/picture_3.jpg" alt="">
        <!-- <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><rect width="100%" height="100%" fill="#777"/></svg> -->
      </div>
      <div class="carousel-item">
        <img style="width:100%" class="img img-responsive" src="img/picture_4.jpg" alt="">
        <!-- <img class="bd-placeholder-img" width="100%" height="100%" xmlns="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTOVPpBJ-rs-daY9UaJoBIY_vvhSQOWhFrLfA" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"></img> -->
      </div>
      <div class="carousel-item">
        <img style="width:100%" class="img img-responsive" src="img/picture_5.jpg" alt="">
        <!-- <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><rect width="100%" height="100%" fill="#777"/></svg> -->
      </div>
      <div class="carousel-item">
        <img style="width:100%" class="img img-responsive" src="img/picture_6.jpg" alt="">
        <!-- <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><rect width="100%" height="100%" fill="#777"/></svg> -->
      </div>
    </div>
    <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>

  <!-- Marketing messaging and featurettes
  ================================================== -->
  <!-- Wrap the rest of the page in another container to center all the content. -->

  <div class="container marketing">

    <!-- <div v-for="car in cars" :key="car.refnum">
      {{car.make}}
      {{car.model}}
    </div> -->

    <!-- Three columns of text below the carousel -->
    <CarList />

    <!-- START THE FEATURETTES -->
    <!-- /END THE FEATURETTES -->

  </div><!-- /.container -->

  <!-- FOOTER -->
  <footer class="container">
    <p class="float-right"><a href="#">Back to top</a></p>
    <p>&copy; 2020 <strong>Fantastico</strong>Motors.</p>
  </footer>
</main>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CarList from './CarList'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: {
    CarList
  },
  computed: {
    ...mapGetters(['getAllCars'])
  },
  methods: {
    gotoCar (e) {
      console.log(e)
      this.$store.commit('setSelCar', e)
      this.$router.push({ path: `/car/${e}` })
    }
  },
  async created () {
  // GET request using fetch with async/await
    const response = await fetch('./cars.json')
    const data = await response.json()
    console.log('THIs car', data[0])
    // this.cars = data
    // this.$store.dispatch('setFavMasjidId', lsMid)
    this.$store.commit('setAllCars', data)

    // console.log(data[0].Images)
    // this.carImages = data[0].Images
    console.log('data 22 from file ', data)
  }
  //,
  // async created () {
  // // GET request using fetch with async/await
  //   const response = await fetch('./cars.json')
  //   const data = await response.json()
  //   console.log('data from file ', data)
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.car-header-avatar{
    width: 140px;
    height: 120px;
    /* -webkit-border-radius: 140px; */
    -webkit-background-clip: padding-box;
    -moz-border-radius: 140px;
    -moz-background-clip: padding;
    border-radius: 5px;
    background-clip: padding-box;
    margin: 7px 0 0 5px;
    /* float: left; */
    background-size: cover;
    background-position: center center;
}

/* CUSTOMIZE THE CAROUSEL
-------------------------------------------------- */

/* Carousel base class */
.carousel {
  margin-bottom: 4rem;
}
/* Since positioning the image, we need to help out the caption */
.carousel-caption {
  bottom: 3rem;
  z-index: 10;
}

/* Declare heights because of positioning of img element */
.carousel-item {
  height: 32rem;
}
/* .carousel-item > img {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  height: 32rem;
} */

/* MARKETING CONTENT
-------------------------------------------------- */

/* Center align the text within the three columns below the carousel */
.marketing .col-lg-4 {
  margin-bottom: 1.5rem;
  text-align: center;
}
.marketing h2 {
  font-weight: 400;
}
.marketing .col-lg-4 p {
  margin-right: .75rem;
  margin-left: .75rem;
}

/* Featurettes
------------------------- */

.featurette-divider {
  margin: 2rem 0; /* Space out the Bootstrap <hr> more */
}

/* Thin out the marketing headings */
.featurette-heading {
  font-weight: 300;
  line-height: 1;
  letter-spacing: -.05rem;
}

/* RESPONSIVE CSS
-------------------------------------------------- */
.jumbotron {
    padding: 4rem 1rem;
    margin-bottom: 2rem;
    background-color: #e9ecef;
    border-radius: .3rem;
}

@media (min-width: 40em) {

  /* Bump up size of carousel content */
  .carousel-caption p {
    margin-bottom: 1.25rem;
    font-size: 1.25rem;
    line-height: 1.4;
    padding-top: 10px;
  }

  .featurette-heading {
    font-size: 50px;
  }
}

@media (min-width: 62em) {
  .featurette-heading {
    margin-top: 1rem;
  }
}

</style>
